import { RESTClient, RESTClientMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';
import { QCPatientVisitDates } from '@dynamika-shared/types/visits';
import { fetchQCPatientVisitsDatesMock } from '@api/mocks/qcPatientVisits';
import { USE_API_MOCKS } from '../env';
import { prepareUrl } from '@utils/routerHelpers';

export type QCPatientVisitsDatesResponse = {
  clinicalTrialId: string;
  siteId: string;
  patientId: string;
  visits: QCPatientVisitDates[];
};

export type MoveVisitOrderBody = {
  previousVisitId: string | null;
  previousVisitDefinitionId: string | null;
};

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchQCPatientVisitsDates = async (
  clinicalTrialId: string,
  patientId: string
) => {
  if (USE_API_MOCKS) {
    fetchQCPatientVisitsDatesMock();
  }
  return api.get<QCPatientVisitsDatesResponse>(
    prepareUrl(API_URL.qcPatientVisitsDates, [patientId]),
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
    }
  );
};

export const lockQCPatientVisit = async (
  clinicalTrialId: string,
  patientId: string,
  visitId: string
) => {
  return api.put(
    prepareUrl(API_URL.qcPatientVisitLock, [patientId, visitId]),
    {},
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
    }
  );
};

export const unlockQCPatientVisit = async (
  clinicalTrialId: string,
  patientId: string,
  visitId: string,
  comment: string
) => {
  return api.put(
    prepareUrl(API_URL.qcPatientVisitUnlock, [patientId, visitId]),
    { comment },
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
    }
  );
};

export const moveQCPatientVisitOrder = async (
  clinicalTrialId: string,
  patientId: string,
  visitId: string,
  body: MoveVisitOrderBody
) => {
  return api.put(
    prepareUrl(API_URL.qcPatientVisitMove, [patientId, visitId]),
    body,
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
    }
  );
};
